module.exports = __webpack_public_path__ + "img/add.7aaeeb76.png";